import {
   ADD_STOCK_APPROVEL,
   APPROVEL_STATUS,
   BACKUP_DATABASE,
   BACKUP_DATABASE_ERROR,
   BACKUP_DATABASE_START,
   BACKUP_DATABASE_SUCCESS,
   DEACTIVATE_DEALER_CHAT,
   DELETE_DEALER_CHAT,
   GENERATE_BULK_EWAY_EINVOICE,
   GET_EWAYBILL_AND_EINVOICE,
   GET_RECEIVE_APPROVAL,
   GET_SYNC_APPROVAL,
   UPDATE_RECEIVED_REQUEST,
} from '../types';
import { POST_MERGE_CODE, POST_COLUMNS_HIDE_SHOW } from '../types';

const initialState = {
   list: [],
   single: null,
   backup: {
      loading: false,
      success: false,
      error: null,
      filename: null,
      size: null,
      timestamp: null,
      message: null,
      status: null,
   },
   ewayBillAndEinvoice: [],
   generateBulkEwayEinvoice: [],
};

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case POST_MERGE_CODE:
         return { ...state, list: payload };

      case POST_COLUMNS_HIDE_SHOW:
         return { ...state, list: payload };

      case BACKUP_DATABASE:
         return {
            ...state,
            single: payload || null,
            backup: {
               ...state.backup,
               success: payload?.success || false,
               message: payload?.message || null,
            },
         };

      // New enhanced backup actions
      case BACKUP_DATABASE_START:
         return {
            ...state,
            backup: {
               ...state.backup,
               loading: true,
               success: false,
               error: null,
               message: null,
            },
         };

      case BACKUP_DATABASE_SUCCESS:
         return {
            ...state,
            backup: {
               ...state.backup,
               loading: false,
               success: true,
               error: null,
               filename: payload.filename,
               size: payload.size,
               timestamp: payload.timestamp,
               message: payload.message,
            },
         };

      case BACKUP_DATABASE_ERROR:
         return {
            ...state,
            backup: {
               ...state.backup,
               loading: false,
               success: false,
               error: payload.error,
               message: payload.error,
               filename: null,
               size: null,
               timestamp: null,
            },
         };

      case GET_EWAYBILL_AND_EINVOICE:
         return { ...state, ewayBillAndEinvoice: payload };

      case GENERATE_BULK_EWAY_EINVOICE:
         return { ...state, generateBulkEwayEinvoice: payload };

      case ADD_STOCK_APPROVEL:
         return { ...state, list: payload };

      case GET_SYNC_APPROVAL:
         return { ...state, syncApprovel: payload };

      case GET_RECEIVE_APPROVAL:
         return { ...state, receiveApprovel: payload };

      case UPDATE_RECEIVED_REQUEST:
         return {
            ...state,
            receiveApprovel: state.receiveApprovel.map(item =>
               item.id === payload.id ? { ...item, ...payload } : item
            ),
         };

      case APPROVEL_STATUS:
         return { ...state, approvelStatus: payload };

      case DELETE_DEALER_CHAT:
         return {
            ...state,
            syncApprovel: state.syncApprovel?.filter(item => item.id !== payload) ?? [],
            receiveApprovel: state.receiveApprovel?.filter(item => item.id !== payload) ?? [],
         };

      case DEACTIVATE_DEALER_CHAT:
         return {
            ...state,
            syncApprovel: state.syncApprovel?.filter(item => item.id !== payload) ?? [],
            receiveApprovel: state.receiveApprovel?.filter(item => item.id !== payload) ?? [],
         };

      default:
         return state;
   }
};

export default reducer;
